import React from 'react'
import ReactivarViaje from './ReactivarViaje'

const DesasociarViaje = ({ShowDesasociarViaje,setShowDesasociarViaje,SelectedDesasociarViajeId,postSaveReactive}) => {
  return (
   <ReactivarViaje ShowReactivarViaje={ShowDesasociarViaje} setShowReactivarViaje={setShowDesasociarViaje} SelectedReactivarViajeId={SelectedDesasociarViajeId}postSaveReactive={postSaveReactive} titles='Desasociar el viaje' textBotton='Si, Desasociar'/>
  )
}

export default DesasociarViaje